<template>
  <SanButton
    size="sm"
    :label="label"
    color="primary-mid"
    icon="mono-arrow-left"
    outline
    @click="onNavigateBack"
  >
    <Tooltip position="right">
      {{ tooltip }}
    </Tooltip>
  </SanButton>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useTranslation } from 'i18next-vue'
// import { useNavigation } from '@/composables'

defineOptions({ name: 'SanButtonBack' })
const props = defineProps({
  label: { type: String, default: null },
  tooltip: { type: String, default: null },
  to: { type: Object, required: true }
})

const $router = useRouter()
// const { navigateBack } = useNavigation()
const { t } = useTranslation()

const tooltip = computed(() => props.tooltip
  ? t('common:Header.toolbar.left.back.tooltip', { tooltip: props.tooltip })
  : t('common:Header.toolbar.left.back.label'))

const onNavigateBack = () => {
  $router.push(props.to)
}
</script>
